import { useCallback } from 'react';
import { FileResponse } from 'providers/api/api';

const useExportReticulationNodesCsv = (
  exportReticulationNodesCsv: (projectId: string) => Promise<FileResponse>,
) => {
  const exportNodesCsv = useCallback(async (projectId: string) => {
    const file = await exportReticulationNodesCsv(projectId);
    const url = window.URL.createObjectURL(file.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = file.fileName ?? `reticulation-nodes-${projectId}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }, [exportReticulationNodesCsv]);

  return { exportNodesCsv };
};

export default useExportReticulationNodesCsv;
